//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "general",
  data() {
    return {
      applicationList: []
    };
  },
  methods: {
    goPage(url) {
      this.$router.push(`/${url}`);
    },
    getApplications() {
      this.$loadingShow();
      this.$get("api/application-item/applications")
        .then(list => {
          if (list) {
            console.log(list);
            this.applicationList = list;
          }
          this.$loadingHide();
        })
        .catch(() => {
          this.$loadingHide();
        });
    },
    goDetail(item) {
      if (item.httpLink) {
        if (
          item.httpLink.indexOf("http://") > -1 ||
          item.httpLink.indexOf("https://") > -1
        ) {
          window.location.href = item.httpLink;
        } else {
          this.$router.push(item.httpLink);
        }
      } else {
        this.$vux.toast.text("请在应用大全配置中增加链接");
      }
    }
  },
  mounted() {
    this.getApplications();
  }
};



// WEBPACK FOOTER //
// ./src/page/home/general.vue